import profileSlice from 'reducers/profile/reducer';

const { actions, reducer } = profileSlice;

export const profileActions = actions;

export default reducer;
